var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "warrantyRef container mg mg--b-4" },
    [
      _c(
        "ma-accordion",
        { ref: "refAccordion", attrs: { expanded: !_vm.shouldCloseAccordion } },
        [
          _c("template", { slot: "accordionTop" }, [
            _c("p", { staticClass: "headline-medium black" }, [
              _vm._v(_vm._s(_vm.$t("warrantyRef.sinisterRef.literal")))
            ])
          ]),
          _c("template", { slot: "accordionBottom" }, [
            _c(
              "div",
              { staticClass: "grid" },
              [
                _c("ma-input-text", {
                  attrs: {
                    value: _vm.stateComWarrantySinisterId,
                    type: "text",
                    name: "refSinisterId",
                    col: "2",
                    icon: "dossier",
                    literal: _vm.$t("warrantyRef.sinisterRef.literal")
                  },
                  on: {
                    change: function($event) {
                      return _vm.handleOnChangeSinisterId($event)
                    },
                    blur: function($event) {
                      return _vm.handleOnBlurSinisterId($event)
                    }
                  }
                }),
                !_vm.stateUserIsReduxMode
                  ? _c("ma-input-text", {
                      attrs: {
                        value: _vm.stateComWarrantySecondaryId,
                        type: "text",
                        name: "refSecondaryId",
                        col: "2",
                        icon: "dossier",
                        literal: _vm.$t("warrantyRef.secondaryRef.literal")
                      },
                      on: {
                        change: function($event) {
                          _vm.stateComWarrantySecondaryId = $event
                        }
                      }
                    })
                  : _vm._e(),
                _vm.stateUserIsReduxMode
                  ? _c("ma-input-text", {
                      attrs: {
                        value: _vm.stateComWarrantyZipCode,
                        type: "text",
                        name: "propsZipCode",
                        col: "2",
                        icon: "ico-cp",
                        literal: _vm.$t("warrantyProps.zipCode.literal")
                      },
                      on: {
                        change: function($event) {
                          _vm.stateComWarrantyZipCode = $event
                        }
                      }
                    })
                  : _vm._e(),
                _vm.isMobilierRoute && _vm.stateUserIsSelfcareAdmin
                  ? _c(
                      "button",
                      {
                        staticClass: "btn mainBlue grid__cell-md-4",
                        on: { click: _vm.handleOpenModal }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("warrantyProps.buttonLink.literal"))
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.stateUserIsSelfcareAdmin
                  ? _c(
                      "ma-modal",
                      {
                        ref: "linkModal",
                        staticClass: "modal-link",
                        attrs: { type: "small" },
                        on: { "modal:close": _vm.closeLinkModal }
                      },
                      [
                        _c("template", { slot: "modalContent" }, [
                          _c("div", { staticClass: "modal__main" }, [
                            _c(
                              "div",
                              { staticClass: "container-content_modal" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "black headline-large mg mg--b-4"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("warrantyProps.modalLink.title")
                                      )
                                    )
                                  ]
                                ),
                                _c("ma-input-select", {
                                  attrs: {
                                    type: "select",
                                    name: "selfCareForms",
                                    col: "4",
                                    icon: "ico-dommages",
                                    literal: _vm.$t("warrantyProps.formsList"),
                                    options: _vm.selfcareForms,
                                    value: _vm.selfcareFormsValue
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.selfcareFormsValue = $event
                                    }
                                  }
                                }),
                                _c("ma-input-select", {
                                  attrs: {
                                    type: "select",
                                    name: "userType",
                                    col: "4",
                                    icon: "dossier",
                                    literal: _vm.$t(
                                      "warrantyProps.userIdsList"
                                    ),
                                    options: _vm.selfcareUsers,
                                    value: _vm.selfcareUsersValue
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.selfcareUsersValue = $event
                                    },
                                    action: _vm.hideUrl
                                  }
                                }),
                                _c("ma-input-select", {
                                  attrs: {
                                    type: "select",
                                    name: "selfcareFnolIds",
                                    col: "4",
                                    icon: "ico-numero-police",
                                    literal: _vm.$t(
                                      "warrantyProps.fnolIdsList"
                                    ),
                                    options: _vm.selfcareFnolIds,
                                    value: _vm.selfcareFnolIdsValue
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.selfcareFnolIdsValue = $event
                                    },
                                    action: _vm.hideUrl
                                  }
                                }),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn mainBlue grid__cell-md-4 mg mg--r-2 mg--t-2",
                                    on: { click: _vm.handleGenerateLink }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "warrantyProps.modalLink.buttonGenerateLink"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn mainBlue cancelBtn grid__cell-md-4",
                                    on: { click: _vm.closeLinkModal }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "warrantyProps.modalLink.buttonCancel"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "container-link_selfcare grid__cell-md-4 mg mg--t-1",
                                class: {
                                  "container-link_selfcare_linkIsVisible":
                                    _vm.showLinkSelfcare
                                }
                              },
                              [
                                _c("svgicon", {
                                  attrs: {
                                    name: "pencil-edit",
                                    height: "8",
                                    widht: "14.67",
                                    color: "#005BA5"
                                  }
                                }),
                                _c(
                                  "a",
                                  {
                                    staticClass: "text-medium blueDark",
                                    attrs: {
                                      target: "blank",
                                      href: _vm.linkSelfCare
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.linkSelfCare))]
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ],
                      2
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }